/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModelDto } from '../../models/user-model-dto';
import { UserSearchDto } from '../../models/user-search-dto';

export interface AdminControllerSearchUsers$Params {
  page: string;
  limit: string;
      body: UserSearchDto
}

export function adminControllerSearchUsers(http: HttpClient, rootUrl: string, params: AdminControllerSearchUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModelDto>>> {
  const rb = new RequestBuilder(rootUrl, adminControllerSearchUsers.PATH, 'post');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserModelDto>>;
    })
  );
}

adminControllerSearchUsers.PATH = '/admin/user/search';
